<template>
	<window-view title="Tildel" v-on="$listeners" :width="400" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<select-view v-model="m.organisationId" :options="_organisations" label="Organisation" />
				</grid-view>			
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import organisation from '../../../model/organisation';

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				id: '',
				m: organisation.model(),
				organisations: [],
			};
		},
		computed: {
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							return self.submit(this.m);
						}
					}
				];
			},
			_organisations() {
				return this.organisations.map(val => {
					return {
						label: val.label,
						value: val.id,
					};
				});
			},
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};

			this.organisations = (await this.axios.get('/organisations?_size=100')).data.content;
		}
	}
</script>

<style lang="scss" scoped>

</style>
